import React, { FC, useCallback } from 'react';
import { TableExtension } from '@remirror/extension-tables';
import { useActive, useCommands } from '@remirror/react-core';
import { CommandButton, CommandButtonProps } from './CommandButton';

export interface CreateTableButtonProps extends Omit<CommandButtonProps, 'commandName' | 'active' | 'enabled' | 'attrs' | 'onSelect'> {
  onClose?: () => void;
}

export const CreateTableButton: FC<CreateTableButtonProps> = (props) => {
  const { createTable } = useCommands<TableExtension>();
  const onClose = props.onClose;

  const handleSelect = useCallback(() => {
    onClose && onClose();
    if (createTable.enabled()) {
      createTable();
    }
  }, [createTable]);

  const active = useActive<TableExtension>().table();
  const enabled = createTable.enabled();

  return <CommandButton {...props} commandName="테이블" active={active} enabled={enabled} onSelect={handleSelect} />;
};
